import { Checkbox } from '@/components/ui/checkbox';
import { computeCosts } from "@/utils/costUtil";

export default function WaiverCheckBox ({ images = [], videos = [], pricing, isFeatured, featuredPaid, includedImages,
																					includedVideos, state, onClick, t }) {

	const cost = computeCosts(images, videos, pricing, isFeatured, featuredPaid, includedImages, includedVideos);

	return (
		<>
			{ cost.total > 0 && (
				<div className="bg-white border border-[#E6E2D6] rounded-sm grid grid-cols-2 p-4 sm:grid-cols-1 gap-2">
					<label className="flex items-center gap-2 cursor-pointer col-span-2 text-sm text-[#3a3a3a] select-none">
						<Checkbox checked={ state } onCheckedChange={ () => onClick(!state) }/>
						{ t('legal.waived_withdrawal') }
					</label>
				</div>
			)}
		</>
	)
}